import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
  getDaylive(params) { //活跃度预警查询
    const url =  baseURL + '/tbUser/DayLive';
    return axios.post(url, qs.stringify(params));
  },

  
}


// WEBPACK FOOTER //
// ./src/api/activityWarn.js